(function() {
    'use strict';

    angular.module('conferencesApp').controller('AdminConferenceSessionsCtrl', function($scope, Session) {

        $scope.sessions = Session.query({conference: $scope.conferenceId});

    });

    angular.module('conferencesApp').controller('AdminConferenceSessionCreateCtrl', function($scope, $state, $q, WORLDSKILLS_API_IMAGES, WSAlert, Session) {

        var photo = $q.when();

        $scope.session = new Session();
        $scope.session.conference = $scope.conference;
        $scope.session.title = {text: '', lang_code: 'en'};
        $scope.session.type = 'presentation';
        $scope.session.description = {text: '', lang_code: 'en'};
    });

    angular.module('conferencesApp').controller('AdminConferenceSessionCtrl', function($scope, $state, $stateParams, WSAlert, Session) {

        $scope.id = $stateParams.sessionId;

        $scope.session = Session.get({conference: $scope.conferenceId, id: $scope.id}, function () {
            $scope.title = $scope.session.title.text;
        });

        $scope.deleteSession = function() {
           if (confirm('Deleting a session will likely break links on the website. Click OK to proceed.')) {
               $scope.deleteLoading = true;
               $scope.session.$delete(function () {
                   WSAlert.success('The session has been deleted successfully.');
                   $state.go('admin_conferences.conference.detail.sessions');
               });
           }
        };
    });

    angular.module('conferencesApp').controller('AdminConferenceSessionFormCtrl', function($scope, $state, $q, Upload, WORLDSKILLS_API_IMAGES, WSAlert, Room, Track, SessionGroup, Session) {

        var image = $q.when();

        $scope.rooms = Room.query({conference: $scope.conferenceId});

        $scope.tracks = Track.query({conference: $scope.conferenceId});

        $scope.groups = SessionGroup.query({conference: $scope.conferenceId});

        $scope.now = new Date();

        var errored = function (httpResponse) {
            if (httpResponse.data.user_msg) {
                alert('Error: ' + httpResponse.data.user_msg);
            } else {
                alert('An error has occured: ' + JSON.stringify(httpResponse.data));
            }
            $scope.loading = false;
        };

        $scope.onFileSelect = function($files) {
            var deferred = $q.defer();
            image = deferred.promise;
            $scope.upload = Upload.upload({
                url: WORLDSKILLS_API_IMAGES,
                file: $files[0],
            }).success(function(data, status, headers, config) {
                deferred.resolve(data);
            });
        };

        $scope.save = function() {
            $scope.submitted = true;
            image.then(function (image) {
                if (!$scope.form.$invalid) {
                    $scope.loading = true;
                    if (typeof image != 'undefined') {
                        $scope.session.image = {id: image.id, thumbnail_hash: image.thumbnail_hash};
                    }
                    if ($scope.session.id) {
                        $scope.session.$update(function () {
                            WSAlert.success('The session has been updated successfully.');
                            $state.go('admin_conferences.conference.detail.sessions');
                        }, errored);
                    } else {
                        $scope.session.$save(function () {
                            WSAlert.success('The session has been added successfully.');
                            $state.go('admin_conferences.conference.detail.sessions');
                        }, errored);
                    }
                }
            });
        };
    });

    angular.module('conferencesApp').controller('AdminConferenceSessionSpeakersCtrl', function($scope, $timeout, WSAlert, Session, SessionSpeaker, Speaker) {

        var getSpeakers = function () {
            $scope.speakers = Speaker.query({conference: $scope.conferenceId}, function () {
                $scope.session.$promise.then(function () {
                    angular.forEach($scope.session.speakers, function (skillSpeaker) {
                        angular.forEach($scope.speakers.speakers, function (speaker) {
                            if (speaker.id === skillSpeaker.id) {
                                speaker.used = true;
                            }
                        });
                    });
                });
            });
        };
        getSpeakers();

        $scope.addSpeaker = function (speaker) {
            SessionSpeaker.update({sessionId: $scope.session.id, speakerId: speaker.id}, {});
            $scope.session.speakers.push(speaker);
            getSpeakers();
            WSAlert.success('The speaker has been added.', '', true);
            return false;
        };

        $scope.removeSpeakers = function() {
            var notRemoved = [];
            angular.forEach($scope.session.speakers, function (speaker, i) {
                if (speaker.checked) {
                    $timeout(function () {
                        SessionSpeaker.remove({sessionId: $scope.session.id, speakerId: speaker.id}, {});
                    }, 100 * i);
                } else {
                    notRemoved.push(speaker);
                }
            });
            $scope.session.speakers = notRemoved;
            getSpeakers();
            WSAlert.success('The selected speaker(s) have been removed.', '', true);
        };
    });

    angular.module('conferencesApp').controller('AdminConferenceSessionFilesCtrl', function($scope, $timeout, WSAlert, Upload, auth, RESOURCES_APP_CODE, WORLDSKILLS_API_RESOURCES, WS_ENTITY_PUBLIC_RESOURCES_ID, RESOURCES_STORAGE_TYPE_LOCAL_FILE, RESOURCES_TYPE_CONFERENCE_UPLOADS, SessionFile) {

        auth.hasUserRole(RESOURCES_APP_CODE, 'CreateResource', WS_ENTITY_PUBLIC_RESOURCES_ID).then(function (hasUserRole) {
            if (hasUserRole) {
                $scope.canUpload = true;
            }
        });

        var errored = function (response) {
            if (response.data) {
                WSAlert.error('Error uploading file(s).', response.data.code + ' ' + response.data.user_msg);
            } else {
                WSAlert.error('Error uploading file(s).', response.status + ' ' + response.statusText);
            }
            $scope.loading = false;
        };

        $scope.fieldUploadFiles = function($files) {
            $scope.session.uploading = $files;
            angular.forEach($files, function(file) {
                var requestData = {
                  name: {text: file.name, lang_code: 'en'},
                  ws_entity: WS_ENTITY_PUBLIC_RESOURCES_ID,
                  types: [RESOURCES_TYPE_CONFERENCE_UPLOADS],
                  metadata: [],
                  version: {
                    name: '1.0',
                    translation: {
                      lang_code: 'en',
                      storage_type: RESOURCES_STORAGE_TYPE_LOCAL_FILE
                    }
                  }
                };
                Upload.upload({
                    url: WORLDSKILLS_API_RESOURCES,
                    data: {requestData: JSON.stringify(requestData), file: file}
                }).then(function (response) {
                    var resourceFile = response.data;
                    var sessionFile = new SessionFile();
                    sessionFile.session_id = $scope.session.id;
                    sessionFile.filename = resourceFile.name.text;
                    sessionFile.resource_id = resourceFile.id;
                    sessionFile.$save(function (sessionFileResponse) {
                        $scope.session.files.push(sessionFileResponse);
                    }, errored);
                }, errored, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            });
        };

        $scope.deleteFile = function (file) {
            var index = $scope.session.files.indexOf(file);
            $scope.session.files.splice(index, 1);
            SessionFile.delete(file);
        };

    });

})();
